/*
 * @Author: liukai
 * @since: 2022-04-21 15:31:20
 * @LastAuthor: liukai
 * @lastTime: 2022-05-04 15:32:10
 */

import checkDevice  from './tools'
function openPage(url){
    url=encodeURI(url)
    console.log(url,'url');
    let device=checkDevice()
    if(device=='ios'){
        location.href=`https://www.hndt.com/dowload/dxXw/index.html?id=${url}&msgType=5`
        // window.webkit.messageHandlers.appRoute.postMessage({url:`hntvdxxw://Common/webViewController?Id=${url}`});
    }else if(device=='andriod'){
        // window.Android.appRoute(`hntvdxxw://Common/webViewController?Id=${url}`);
        window.Android.appRoute(`${url}`);
    }

}

function openArticle(id){
    let device=checkDevice()
    if(device=='ios'){
        //ios
        // window.webkit.messageHandlers.appRoute.postMessage({url:`hntvdxxw://Article/articleDetailViewController?articleId=${id}`});
        window.location=`${id}`
    }else if(device=='andriod'){
        //安卓
        window.Android.appRoute(`hntvdxxw://Article/articleDetailViewController?articleId=${id}`);
    }
    
}

//跳转专题
function openZhuanti(id){
    console.log('zhuanti',id);
    // id='1452832948898357250'
    let device=checkDevice()
    if(device=='ios'){
        //ios
        window.webkit.messageHandlers.appRoute.postMessage({url:`hntvdxxw://Article/zhuantiViewController?articleId=${id}`});
    }else if(device=='andriod'){
        //安卓
        window.Android.appRoute(`hntvdxxw://Article/articleDetailViewController?articleId=${id}`);
    }
    
}
//跳转app模板页
function openTemplete(id){
    let device=checkDevice()
    if(device=='ios'){
        //ios
        window.webkit.messageHandlers.appRoute.postMessage({url:`hntvdxxw://Common/templeteViewController?schemeName=${id}`});
    }else if(device=='andriod'){
        //安卓
        window.Android.appRoute(`hntvdxxw://Common/templeteViewController?schemeName=${id}`);
    }
    
}

//唤醒app
 function wakeApp(articleId){
    let device=checkDevice()
    if(device=='ios'){
        //ios
        window.location.href = `https://www.hndt.com/dowload/dxXw/index.html?id=${articleId}&msgType=32`
    }else if(device=='andriod'){
        //安卓
        window.location.href = `https://a.app.qq.com/o/simple.jsp?pkgname=com.hnr.dxxw&android_schema=schemedxxw%3a%2f%2fhostdxxw%3a8080%2fpath?id=${articleId}%26msgType=32`
        
    }
 }




export {openPage,openArticle,openZhuanti,openTemplete,wakeApp}